import { useQuery } from "@tanstack/react-query"
import { getSellerQuotationById } from "@/lib/api/quotation.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetSellerQuotationById(id: string) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["seller-quotation-detail", id],
    queryFn: () => getSellerQuotationById(id, accessToken!),
    enabled: !!accessToken && !!id,
    staleTime:0,
  })
}
